import ingresoService from '../services/ingresoService';

export const FETCH_INGRESOS_REQUEST = 'FETCH_INGRESOS_REQUEST';
export const FETCH_INGRESOS_SUCCESS = 'FETCH_INGRESOS_SUCCESS';
export const FETCH_INGRESOS_FAILURE = 'FETCH_INGRESOS_FAILURE';

export const FETCH_INGRESO_REQUEST = 'FETCH_INGRESO_REQUEST';
export const FETCH_INGRESO_SUCCESS = 'FETCH_INGRESO_SUCCESS';
export const FETCH_INGRESO_FAILURE = 'FETCH_INGRESO_FAILURE';

export const CREATE_INGRESO_REQUEST = 'CREATE_INGRESO_REQUEST';
export const CREATE_INGRESO_SUCCESS = 'CREATE_INGRESO_SUCCESS';
export const CREATE_INGRESO_FAILURE = 'CREATE_INGRESO_FAILURE';

export const UPDATE_INGRESO_REQUEST = 'UPDATE_INGRESO_REQUEST';
export const UPDATE_INGRESO_SUCCESS = 'UPDATE_INGRESO_SUCCESS';
export const UPDATE_INGRESO_FAILURE = 'UPDATE_INGRESO_FAILURE';

export const DELETE_INGRESO_REQUEST = 'DELETE_INGRESO_REQUEST';
export const DELETE_INGRESO_SUCCESS = 'DELETE_INGRESO_SUCCESS';
export const DELETE_INGRESO_FAILURE = 'DELETE_INGRESO_FAILURE';

export const fetchIngresos = () => async (dispatch) => {
  dispatch({ type: FETCH_INGRESOS_REQUEST });
  try {
    const response = await ingresoService.fetchIngresos();
    dispatch({ type: FETCH_INGRESOS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_INGRESOS_FAILURE, payload: error.message });
  }
};


export const fetchIngreso = (nrorec) => async (dispatch) => {
  dispatch({ type: FETCH_INGRESO_REQUEST });
  try {
    const response = await ingresoService.fetchIngreso(nrorec);
    dispatch({ type: FETCH_INGRESO_SUCCESS, payload: response.data });
    return { payload: response.data }; // Devuelve los datos explícitamente
  } catch (error) {
    dispatch({ type: FETCH_INGRESO_FAILURE, payload: error.message });
    return { error: error.message };
  }
};
export const createIngreso = (ingresoData) => async (dispatch) => {
  dispatch({ type: CREATE_INGRESO_REQUEST });
  try {
    const response = await ingresoService.createIngreso(ingresoData);
    dispatch({ type: CREATE_INGRESO_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const updateIngreso = (id, ingresoData) => async (dispatch) => {
  dispatch({ type: UPDATE_INGRESO_REQUEST });
  try {
    const response = await ingresoService.updateIngreso(id, ingresoData);
    dispatch({ type: UPDATE_INGRESO_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const deleteIngreso = (id) => async (dispatch) => {
  dispatch({ type: DELETE_INGRESO_REQUEST });
  try {
    await ingresoService.deleteIngreso(id);
    dispatch({ type: DELETE_INGRESO_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};